// client/src/constants/sensors.js
export const SENSOR_NAME_MAP = {
    mini_co2: 'CO2-mini ATM',
    procv_co2: 'CO2-Pro ATM',
    CTD: 'CTD',
    sensor_data: 'Fluorometer',
    telemetry: 'Telemetry',
    virtual_tide: 'Halifax Tide',
    virtual_wind: 'Wind',
    virtual_temperature: 'Temperature',
    virtual_currents: 'Currents',
    virtual_waves: 'Waves',
    virtual_ctd: 'CTD'
  };

// Order to display CT2001 sensors in the sidebar tree (matches the
// instructions document: Fluorometer → CTD → CO2-Pro ATM → CO2-mini ATM).
export const CT2001_SENSOR_ORDER = [
  'sensor_data',
  'CTD',
  'procv_co2',
  'mini_co2',
];

// For each sensor, which fields are "Parameters" (derived/calibrated outputs).
// All other available fields fall into "Raw data".
export const SENSOR_PARAMETER_FIELDS = {
  sensor_data: ['bb', 'chl', 'cdom', 'chl_ug_l', 'cdom_ppb', 'bb_m_1_sr_1'],
  CTD: ['temperature_c', 'pressure[dbar]', 'oxygen_ml_per_l', 'salinity_psu'],
  procv_co2: ['pCO2', 'gas_pressure_mbar'],
  mini_co2: ['pCO2', 'gas_pressure_mbar'],
};
  
  export const SENSOR_FIELDS = {
    mini_co2: {
      pCO2: 'pCO₂',
      corrected_co2_ppmv: 'Corrected CO₂',
      raw_co2_ppm: 'Raw CO₂',
      reference_ad_counts: 'Reference AD Counts',
      sensor_temperature_c: 'Sensor Temperature',
      logger_temp_ad_counts: 'Logger Temp AD Counts',
      gas_pressure_mbar: 'Gas Pressure'
    },
    procv_co2: {
      pCO2: 'pCO₂ [μatm]',
      calculated_co2_ppmv: 'Calculated CO₂ [ppmv]',
      current_ad_counts: 'Current AD Counts',
      current_counts: 'Current Counts',
      epoch_time: 'Epoch Time',
      gas_pressure_mbar: 'Gas Pressure [mbar]',
      humidity_mbar: 'Humidity [mbar]',
      humidity_sensor_temp_c: 'Humidity Temp [°C]',
      irga_temperature_c: 'IRGA Temp [°C]',
      logger_temp_ad_counts: 'Logger Temp AD Counts',
      raw_co2_ppmv: 'Raw CO₂ [ppmv]',
      supply_voltage_v: 'Supply Voltage [V]',
      zero_ad_counts: 'Zero AD Counts'
    },
    CTD: {
      temperature_c: 'Temperature',
      'conductivity[S/m]': 'Conductivity',
      'pressure[dbar]': 'Pressure',
      oxygen_ml_per_l: 'Oxygen',
      salinity_psu: 'Salinity',
      'sound_velocity[m/s]': 'Sound Velocity',
      'specific_conductivity[S/m]': 'Specific Conductivity'
    },
    virtual_tide: {
        water_level_m: "Observed Water Level",
        prediction_m: "Predicted Water Level"
      },
      
      virtual_waves: {
        hs_m: "Sig Wave Height",
        hmax_m: "Max Wave Height",
        tmax_s: "Max Wave Period",
        dir_mean_deg: "Avg Wave Direction",
        spread_deg: "Directional Spread"
      },
      
      virtual_wind: {
        wind_speed_avg_mps: "Avg Wind Speed",
        wind_speed_max_mps: "Max Wind Speed",
        wind_dir_avg_deg: "Avg Wind Direction"
      },
      
      virtual_currents: {
        speed_mps: "Current Speed ",
        dir_deg: "Current Direction"
      },
      
      virtual_temperature: {
        air_temp_c: "Air Temperature",
        msl_pressure_hpa: "Avg Sea Lvl Pressure",
        sea_surface_temp_c: "Sea Surf Temp"
      },
      
      virtual_ctd: {
        temperature_deg_c: "Temperature",
        salinity_psu: "Salinity",
        pressure_dbar: "Pressure",
        oxygen_mg_l: "Oxygen",
        sound_velocity_m_s: "Sound Velocity",
        conductivity_s_m: "Conductivity"
      }
  };
  


